var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_841_27895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.103516,
    y: 0.742065,
    width: 34.462,
    height: 34.4619,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_841_27895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.20584 26.0642C5.90071 26.0642 5.64494 25.9609 5.43853 25.7544C5.23211 25.5479 5.12891 25.292 5.12891 24.9868C5.12891 24.6815 5.23211 24.4258 5.43853 24.2196C5.64494 24.0134 5.90071 23.9103 6.20584 23.9103H28.4625C28.7676 23.9103 29.0234 24.0136 29.2298 24.2201C29.4362 24.4266 29.5394 24.6825 29.5394 24.9877C29.5394 25.293 29.4362 25.5487 29.2298 25.7549C29.0234 25.9611 28.7676 26.0642 28.4625 26.0642H6.20584ZM6.20584 19.0503C5.90071 19.0503 5.64494 18.947 5.43853 18.7405C5.23211 18.534 5.12891 18.2782 5.12891 17.9729C5.12891 17.6676 5.23211 17.4119 5.43853 17.2057C5.64494 16.9996 5.90071 16.8965 6.20584 16.8965H28.4625C28.7676 16.8965 29.0234 16.9997 29.2298 17.2062C29.4362 17.4127 29.5394 17.6686 29.5394 17.9738C29.5394 18.2791 29.4362 18.5348 29.2298 18.741C29.0234 18.9472 28.7676 19.0503 28.4625 19.0503H6.20584ZM6.20584 12.0364C5.90071 12.0364 5.64494 11.9332 5.43853 11.7267C5.23211 11.5202 5.12891 11.2643 5.12891 10.959C5.12891 10.6538 5.23211 10.3981 5.43853 10.1919C5.64494 9.98568 5.90071 9.88258 6.20584 9.88258H28.4625C28.7676 9.88258 29.0234 9.98584 29.2298 10.1923C29.4362 10.3989 29.5394 10.6547 29.5394 10.96C29.5394 11.2653 29.4362 11.521 29.2298 11.7272C29.0234 11.9333 28.7676 12.0364 28.4625 12.0364H6.20584Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHam);
export default __webpack_public_path__ + "static/media/ham.bb91e498d948c0d7d9cb6ad5a100cf93.svg";
export { ForwardRef as ReactComponent };